<template>
    <div>
        <h2>{{$t('message.dashboard_transmitters')}}</h2>
        <p>🔔 {{$t('message.transmitter_battery_alarm')}} <b>{{this.activeUser.email}}</b></p>
        <download-export-buttons resource="transmitter" />
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>{{$t('message.serial_number')}}</th>
                    <th>{{$t('message.name')}}</th>
                    <th>{{$t('message.building')}}</th>
                    <th>{{$t('message.unit')}}</th>
                    <th>{{$t('message.measurement')}}</th>
                    <th>{{$t('message.battery_status')}}</th>
                    <th>{{$t('message.signal')}}</th>
                    <th>{{$t('message.last_data')}}</th>
                    <th>{{$t('message.first_data')}}</th>
<!--                    <th></th>-->
                </tr>
            </thead>
            <tbody>
                <template v-if="loading || transmitters.length === 0">
                    <table-list-status :loading="loading" :colspan="9" />
                </template>
                <template v-else>
                    <tr v-for="transmitter in transmitters" :key="transmitter.serial_number">
                        <td>
                            {{transmitter.serial_number}}
                        </td>
                        <td>
                            {{transmitter.name}}
                        </td>
                        <td>
                            {{transmitter.building}}
                        </td>
                        <td>
                            {{transmitter.unit}}
                        </td>
                        <td>
                            {{transmitter.measurement}}
                        </td>
                        <td>
                            <battery :value="transmitter.battery"></battery>
                        </td>
                        <td>
                            <Signal :rssi="transmitter.rssi"></Signal>
                        </td>
                        <td>
                            {{transmitter.last_data}}
                        </td>
                        <td>
                            {{transmitter.first_data}}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <DownloadTransmitterData ref="downloadData"/>
    </div>
</template>

<script>
    import mixins from '../modules/mixins'
    import strorage, {TRANSMITTERS_REQUEST} from '../_store'
    import Battery from './Battery'
    import Signal from './Signal'
    import DownloadTransmitterData from './dashboard/modal/DownloadTransmitterData'
    import DownloadExportButtons from './DownloadExportButtons'
    import TableListStatus from './TableListStatus'

    export default {
        name: 'Transmitters',
        mixins: [mixins],
        components: {
            Battery,
            Signal,
            DownloadTransmitterData,
            DownloadExportButtons,
            TableListStatus
        },
        data () {
            return {
                loading: true,
                transmitters: []
            }
        },
        methods: {
            openModal (transmitter) {
                this.$refs['downloadData'].show(transmitter)
            }
        },
        created () {
            if (!this.activeUser.email) {
                this.loadUser()
            }
            strorage.dispatch(TRANSMITTERS_REQUEST)
                .then(resp => {
                    this.transmitters = resp.data.transmitters.map((value) => {
                        if (value.medium === 'heat') {
                            value.serial_number = this.decodeITN(value.serial_number.replace('-', ''))
                        }
                        return value
                    })
                })
                .catch(err => {
                    this.$b_notify({
                        type: 'danger',
                        content: err
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
</script>

<style scoped>

</style>
